import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import LineLogin from 'components/atoms/LineLogin';
import { GoogleButtonWithHook } from '@z-components/atoms/GoogleButton';
import { logEvent } from 'utils/analytics';
import {
  createTelemetryBeacon,
  sendTelemetryBeacon,
  setPersistentTracingIdentifiersInCookies,
} from 'utils/telemetry';
import { ContextEnum } from '@z-components/utils/oauth';

import styles from './SocialRegistration.module.scss';

const SocialRegistration: FC = () => {
  const { t } = useTranslation('staticPages');
  const handleGoogleButtonClicked = useCallback(() => {
    logEvent('proSignUp', 'socialAuthentication', 'google');
    sendTelemetryBeacon(
      createTelemetryBeacon({
        action: 'OAuthLogin_navToConsentPage',
        context: ContextEnum.proRegistration,
        provider: 'google',
      })
    );
    setPersistentTracingIdentifiersInCookies();
  }, []);

  return (
    <div className={styles['container']}>
      <div className={styles['sso-login-header']}>
        {t('pro.socialAuth.externalAccountRegister')}
      </div>
      <LineLogin
        context={ContextEnum.proRegistration}
        onClick={() => logEvent('proSignUp', 'socialAuthentication', 'line')}
      />
      <GoogleButtonWithHook
        onGoogleLoginClick={handleGoogleButtonClicked}
        context={ContextEnum.proRegistration}
        googleRedirectUri={process.env.GOOGLE_LOGIN_REDIRECT_URI}
        clientId={process.env.GOOGLE_SIGN_IN_CLIENT_ID ?? ''}
      />
    </div>
  );
};

export default SocialRegistration;
